var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Flooring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M39.494,20.494c-0.254,0.254-0.606,0.412-0.994,0.412c-0.776,0-1.406-0.629-1.406-1.406 c0-0.388,0.157-0.74,0.412-0.994L36,17l-6,6l1.499,1.499c0.256-0.256,0.61-0.414,1.001-0.414c0.781,0,1.415,0.634,1.415,1.415 c0,0.391-0.158,0.744-0.414,1.001L35,28l6-6L39.494,20.494z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZycMi6rhrQhf5C_mU1Obza",
    x1: 17.836,
    x2: 17.836,
    y1: 18.473,
    y2: 45.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZycMi6rhrQhf5C_mU1Obza)",
    d: "M24.672,17.328L24,18l-7,7L5.586,36.414c-0.781,0.781-0.781,2.047,0,2.828l3.172,3.172 c0.781,0.781,2.047,0.781,2.828,0l19.086-19.086L24.672,17.328z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZycMi6rhrQhf5C_mU1Obzb",
    x1: 35.766,
    x2: 41.881,
    y1: 22.766,
    y2: 28.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZycMi6rhrQhf5C_mU1Obzb)",
    d: "M43.707,22.879l-2.586-2.586c-0.391-0.391-1.024-0.391-1.414,0l-6.414,6.414 c-0.391,0.391-0.391,1.024,0,1.414l2.586,2.586c0.391,0.391,1.024,0.391,1.414,0l6.414-6.414 C44.098,23.902,44.098,23.269,43.707,22.879z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZycMi6rhrQhf5C_mU1Obzc",
    x1: 12.377,
    x2: 40.952,
    y1: -0.623,
    y2: 27.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZycMi6rhrQhf5C_mU1Obzc)",
    d: "M37.707,16.879l-9.364-9.364C26.093,5.264,23.041,4,19.858,4h-4.813 C14.468,4,14,4.468,14,5.045v0c0,0.541,0.412,0.992,0.951,1.041l2.262,0.206c2.963,0.269,5.601,1.985,7.048,4.584L26,14 l-2.707,2.707c-0.391,0.391-0.391,1.024,0,1.414l6.586,6.586c0.391,0.391,1.024,0.391,1.414,0l6.414-6.414 C38.098,17.902,38.098,17.269,37.707,16.879z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Flooring);
export default __webpack_public_path__ + "static/media/icons8-flooring.23b98be4ddb476e52f11ae4fd7b103d0.svg";
export { ForwardRef as ReactComponent };